/**
 * Lógica pura del desglose por moneda — sin DOM, sin bundler.
 *
 * Vive aparte del componente para poder testearse en Node: decide QUÉ decir sobre
 * un total consolidado (motivo del hueco, lectura de la tasa, si hay algo que
 * explicar). El componente `desglose-moneda-popover.js` solo lo pinta.
 */

/** Un desglose sirve solo si trae al menos una moneda con su monto. */
export function hayDesgloseUtil(meta) {
    return Boolean(meta && Array.isArray(meta.desglose) && meta.desglose.length > 0);
}

/**
 * Motivo por el que el total no es exacto. La causa importa porque cada una se
 * arregla en un lugar distinto: una moneda sin declarar se corrige en la ficha del
 * nodo; una tasa ausente, cargando cotizaciones.
 * @param {Object} meta - moneda_meta del endpoint
 * @param {(s: string) => string} traducir
 */
export function motivoDelTotal(meta, traducir) {
    const t = traducir || (s => s);
    if (meta && meta.nodos_sin_moneda) return t('Hay nodos sin moneda configurada: su dinero no se pudo convertir');
    if (meta && meta.tasa_faltante) return t('Faltan tasas de cambio: el total no se pudo consolidar');
    return t('Total convertido con la tasa del día: es aproximado');
}

/**
 * Tasa en lenguaje humano: "1 PYG = 0.000705 BRL".
 * Las tasas muy chicas (guaraní a real) llevan más decimales: con 4 se leerían
 * como 0.0000, o sea "no vale nada", que es justo lo contrario del dato.
 */
export function lineaDeTasa(monedaOrigen, monedaDestino, tasa, traducir) {
    const t = traducir || (s => s);
    if (tasa === null || tasa === undefined) return t('sin cotización');
    if (monedaOrigen === monedaDestino) return t('moneda del total');
    const decimales = Math.abs(tasa) < 0.01 ? 6 : 4;
    return `1 ${monedaOrigen} = ${tasa.toFixed(decimales)} ${monedaDestino}`;
}

/**
 * Qué marca corresponde a un total: '≈' si se convirtió, '— !' si no se pudo
 * consolidar, o cadena vacía si el total es exacto (nada que aclarar).
 */
export function marcaDelTotal(meta, opciones = {}) {
    if (!hayDesgloseUtil(meta)) return '';
    if (opciones.hueco || meta.tasa_faltante) return '— !';
    if (meta.consolidado_aproximado) return '≈';
    return '';
}
